import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';

import LocationIDHelp from '../img/location_id_help.png';
import '../index.scss';

export default class BookerAccountInfo extends React.Component {
  constructor(props) {
    super(props);

    const { business } = this.props;

    let name = '';
    let email = '';

    if (business && business.info) {
      name = `${business.info.FIRST_NAME ? business.info.FIRST_NAME : ''} ${
        business.info.LAST_NAME ? business.info.LAST_NAME : ''
      }`.trim();
      email = business.info.EMAIL ? business.info.EMAIL : '';
    }

    this.state = {
      name,
      businessAccount: '',
      email,
      locationID: '',
      address: '',
      mandatoryFieldError: false,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.validate = this.validate.bind(this);
  }

  onInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  onNextButtonClick() {
    const { name, businessAccount, email, address, locationID } = this.state;

    const data = {
      name,
      businessAccount,
      email,
      address,
      locationID,
    };
    const validationResult = this.validate(data);

    if (validationResult) {
      this.props.postBookerAccountInfo(data);
    }
  }

  validate(data) {
    if (
      !data.name ||
      !data.businessAccount ||
      !data.email ||
      !data.locationID ||
      !data.address
    ) {
      this.setState({
        mandatoryFieldError: true,
      });

      return false;
    }

    this.setState({
      mandatoryFieldError: false,
    });

    return true;
  }

  render() {
    const {
      name,
      email,
      businessAccount,
      locationID,
      address,
      mandatoryFieldError,
    } = this.state;
    const { softwares } = this.props;

    // const emailContent = {
    //   subject: 'Request Authorization for TrueLark',
    //   body: `Hi Booker API Team! \n\nI would like to grant API access to TrueLark for my Booker Account.\n\nHere are details for my account: \n* Account Name: ${businessAccount}\n* Location ID: ${locationID}\n* Primary Contact Name: ${name}\n* Primary Contact Email Address: ${email}\n Thank You.`,
    //   to: 'api.support@booker.com',
    //   cc: 'support@truelark.com',
    // };

    // const mailtoURL = `mailto:${emailContent.to}?subject=${encodeURIComponent(emailContent.subject)}&body=${encodeURIComponent(emailContent.body)}&cc=${emailContent.cc}`;

    return (
      <div className="authorize-access">
        <form className="authorize-access__form">
          {mandatoryFieldError ? (
            <p className="authorize-access__error">
              <i className="material-icons" aria-hidden="true">error</i>
              Fields marked in red are mandatory!
            </p>
          ) : null}
          {softwares.isBookerAccountInfoSaveFail ? (
            <p className="authorize-access__error">
              <i className="material-icons" aria-hidden="true">error</i>
              Unable to save account information
            </p>
          ) : null}
          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">PRIMARY CONTACT NAME*</p>
            <input
              type="text"
              name="name"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={name}
              onChange={this.onInputChange}
              autoComplete="false"
            />
          </div>

          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">
              PRIMARY CONTACT EMAIL ADDRESS*
            </p>
            <input
              type="text"
              name="email"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={email}
              onChange={this.onInputChange}
              autoComplete="false"
            />
          </div>

          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">BUSINESS ACCOUNT NAME*</p>
            <input
              type="text"
              name="businessAccount"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={businessAccount}
              onChange={this.onInputChange}
              autoComplete="false"
            />
          </div>

          <a
            className="authorize-access__help-text"
            data-tip
            data-for="locationidhelp"
          >
            How to find your Account & Location IDs?
          </a>

          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">LOCATION ID*</p>
            <input
              type="text"
              name="locationID"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={locationID}
              onChange={this.onInputChange}
              autoComplete="false"
            />
          </div>

          <a
            className="authorize-access__help-text"
            data-tip
            data-for="locationidhelp"
          >
            How to find your Account & Location IDs?
          </a>

          <ReactTooltip
            id="locationidhelp"
            className="authorize-access__help-tooltip"
          >
            <img src={LocationIDHelp} alt="Location ID" width="400" />
          </ReactTooltip>

          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">ENTER ADDRESS*</p>
            <input
              type="text"
              name="address"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={address}
              onChange={this.onInputChange}
              autoComplete="false"
            />
          </div>
        </form>
        <div className="authorize-access__actions">
          <button
            className="btn btn--secondary btn--lg"
            type="button"
            onClick={this.props.onBackClick}
          >
            Go Back
          </button>
          <button
            className="btn btn--primary btn--lg"
            onClick={this.onNextButtonClick}
            disabled={softwares.isSavingBookerAccountInfo}
          >
            {!softwares.isSavingBookerAccountInfo ? 'NEXT' : 'Saving...'}
          </button>
        </div>
      </div>
    );
  }
}

BookerAccountInfo.defaultProps = {
  postBookerAccountInfo: () => {},
  onBackClick: () => {},
};

BookerAccountInfo.propTypes = {
  postBookerAccountInfo: PropTypes.func,
  onBackClick: PropTypes.func,
  business: PropTypes.shape().isRequired,
  softwares: PropTypes.shape().isRequired,
};
